{
  // Client-side date guard for global popups. Handles cached pages where PHP
  // rendered the popup but the date window has since opened or closed.
  function applyDateGuard(){
    const now = new Date()

    document.querySelectorAll('ada-modal[data-content-id]').forEach(modal => {
      const startStr = modal.getAttribute('data-start-date')
      const endStr   = modal.getAttribute('data-end-date')
      if(!startStr && !endStr) return

      // ACF returns "Y-m-d H:i:s" — replace the space with T for Safari-safe parsing
      const start = startStr ? new Date(startStr.replace(' ', 'T')) : null
      const end   = endStr   ? new Date(endStr.replace(' ', 'T'))   : null

      const beforeWindow = start && !isNaN(start) && now < start
      const afterWindow  = end   && !isNaN(end)   && now > end

      if(beforeWindow || afterWindow){
        // ada-modal moves itself into a backdrop on connectedCallback and sets
        // a setTimeout for openModal — drop both so the timer can't paint an
        // orphaned overlay against a detached modal.
        if(modal.backdrop) modal.backdrop.remove()
        modal.remove()
      }
    })
  }

  // Auto-open queue: when one popup's timer fires while another is open, FIFO
  // queue it instead of stacking. Manual triggers via `#popup-id` links go
  // through the same override and queue naturally if something else is showing.
  function applyAutoOpenQueue(){
    const autoModals = Array.from(document.querySelectorAll('ada-modal[auto-open-delay]'))
    if(autoModals.length < 2) return

    const queue = []
    let busy = false

    function advance(){
      if(busy || queue.length === 0) return
      const next = queue.shift()
      busy = true
      next._originalOpenModal()
      next.addEventListener('close', () => {
        busy = false
        advance()
      }, { once: true })
    }

    autoModals.forEach(modal => {
      modal._originalOpenModal = modal.openModal.bind(modal)
      modal.openModal = function(){
        if(!queue.includes(modal)) queue.push(modal)
        advance()
      }
    })
  }

  applyDateGuard()
  // Wait for ada-modal to upgrade so `openModal` is on the prototype before we wrap it.
  customElements.whenDefined('ada-modal').then(applyAutoOpenQueue)
}
